<template>
 <div class="page flex-col">
    <div class="block_14 flex-col">
      <div class="group_2 flex-row justify-between align-center" style="justify-content: stretch;padding-left: 10px;">
        <i class="el-icon-arrow-left" style="font-size:18px;color:#ffffff;" @click="back()"></i>
        <span class="text_70">患者主页</span>
      </div>
    </div>
    <div class="block_15 flex-col">
      <div class="box_3 flex-col">
        <div class="image-text_5 flex-row justify-between">
          <img
            class="image_7"
            referrerpolicy="no-referrer"
            :src="surgeryInfo.sex == `女` ? `static/img/mobile/female.svg` : `static/img/mobile/male.svg`"
          />
          <div class="text-group_4 flex-col">
            <div class="text-wrapper_48 flex-row justify-between">
              <span class="text_4">{{surgeryInfo.patient_name}}</span>
              <span class="text_5">{{surgeryInfo.sex}}/{{surgeryInfo.age}}/{{surgeryInfo.bed_no}}/{{surgeryInfo.visit_no}}</span>
            </div>
            <span class="text_6">{{surgeryInfo.surgeries}}</span>
          </div>
        </div>
        <div class="image-text_6 flex-row justify-between" @click="showMore=!showMore">
          <span class="text-group_2">{{showMore?`收起更多`:`查看更多`}}</span>
           <i :class="showMore?'el-icon-caret-top':'el-icon-caret-bottom'" style="font-size: 18px;color: #999999;margin-top: -2px;"></i>
        </div>
            <div v-if="showMore" class="surgery flex-row justify-between">
                <div>
                  <span>手术台次</span>
                  <span style="color: rgba(51, 51, 51, 1); width: 59%;">{{surgeryInfo.scheduled_sequence}}</span>
                </div>
                <div>
                  <span>手术间</span>
                  <span style="color: rgba(51, 51, 51, 1); width: 59%;">{{surgeryInfo.dic_operating_room}}</span>
                </div>
            </div>
            <div v-if="showMore" class="surgery flex-row justify-between">
                <div>
                  <span>手术科室</span>
                  <span style="color: rgba(51, 51, 51, 1); width: 59%;">{{surgeryInfo.dic_section}}</span>
                </div>
                <div>
                  <span>术前诊断</span>
                  <span style="color: rgba(51, 51, 51, 1); width: 59%;">{{surgeryInfo.plan_diseases}}</span>
                </div>
            </div>
            <div v-if="showMore" class="surgery flex-row justify-between">
                <div>
                  <span>手术医生</span>
                  <span style="color: rgba(51, 51, 51, 1); width: 59%;">{{surgeryInfo.surgeon}}</span>
                </div>
                <div>
                  <span>手术部位</span>
                  <span style="color: rgba(51, 51, 51, 1); width: 59%;">{{surgeryInfo.surgical_site}}</span>
                </div>
            </div>
            <div v-if="showMore" class="surgery flex-row justify-between">
                <div style="width:100%;">
                  <span style="width: 20%;">麻醉方式</span>
                  <span style="color: rgba(51, 51, 51, 1); width: 79%;">{{surgeryInfo.anaes_methods}}</span>
                </div>
            </div>
            <div v-if="showMore" class="surgery flex-row justify-between">
                <div style="width:100%;">
                  <span style="width: 35%;">手术计划开始时间</span>
                  <span style="color: rgba(51, 51, 51, 1); width: 64%;text-align: left;">{{surgeryInfo.plan_time && this.$moment(surgeryInfo.plan_time).format(`YYYY-MM-DD HH:mm`)}}</span>
                </div>
            </div>
      </div>
      <div class="box_4 flex-col justify-between">
            <vtabs v-model="activeTab" style="border-bottom: solid 1px #d9d9d999;">
                <vtab v-for="(tab, index) in tabsGroup" :key="index" :title="tab.title" v-if="isHavePermission(tab.permission)"  :name="tab.name">
                </vtab>
            </vtabs>
            <TimeLine v-if="activeTab=='timeline'" :surgeryId="surgeryId" :surgeryInfo="surgeryInfo" :visible="activeTab=='timeline'" :style="{'height':`${ screenHeight - 210}px`}"></TimeLine>
            <DeviceBind v-if="activeTab=='deviceBind'" :surgeryId="surgeryId" :surgeryInfo="surgeryInfo" :visible="activeTab=='deviceBind'" :style="{'height':`${ screenHeight - 210}px`}"></DeviceBind>
            <DoucmentList v-if="activeTab=='doc'" :surgeryId="surgeryId" :surgeryInfo="surgeryInfo" :visible="activeTab=='doc'" :style="{'height':`${ screenHeight - 210}px`}"></DoucmentList>
            <DocList v-if="activeTab=='PDADoc'" :surgeryId="surgeryId" :surgeryInfo="surgeryInfo" :visible="activeTab=='PDADoc'" :style="{'height':`${ screenHeight - 210}px`}"></DocList>
            <SaftyCheckMobile v-if="activeTab=='saftCheck'" :surgeryId="surgeryId" :surgeryInfo="surgeryInfo" :visible="activeTab=='saftCheck'" :style="{'height':`${ screenHeight - 210}px`}"></SaftyCheckMobile>
      </div>
    </div>
  </div>
</template>

<script>
import TimeLine from './TimeLine.vue'
import DeviceBind from './DeviceBind.vue'
import DoucmentList from './DoucmentList.vue'
import DocList from './DocList.vue'
import SaftyCheckMobile from './SaftyCheck/SaftyCheckMobile.vue'

import 'vant/lib/index.css'
import {
    Tab as vtab,
    Tabs as vtabs,
    DropdownMenu as vdropdownmenu,
    DropdownItem as vdropdownitem,
    Button as vbutton,
    PullRefresh as vpullrefresh,
    List as vlist,
    Empty as vempty,
    DatetimePicker as vdatetimepicker,
    Popup as vpopup,
    Tabbar as vtabbar,
    TabbarItem as vtabbaritem,
    Tag as vtag,
    Dialog,
    Field as vfield,
    Toast
} from 'vant'
import { mapGetters } from 'vuex'
export default {
    name: `SurgeryDetail`,
    components: {
        vtab,
        vtabs,
        vdropdownmenu,
        vdropdownitem,
        vbutton,
        vpullrefresh,
        vlist,
        vempty,
        vdatetimepicker,
        vpopup,
        vtabbar,
        vtabbaritem,
        vtag,
        [Dialog.Component.name]: Dialog.Component,
        vfield,
        Toast,
        TimeLine,
        DeviceBind,
        DoucmentList,
        DocList,
        SaftyCheckMobile
    },
    data() {
        let sessionSurgeryObj = sessionStorage.getItem(`surgeryInfo`)
        let sessionSurgeryInfo = sessionSurgeryObj && JSON.parse(sessionSurgeryObj) || null
        return {
            tabsGroup: [{ title: `时间点`, name: `timeline`, permission: `mobile:timeline` }, { title: `设备绑定`, name: `deviceBind`, permission: `mobile:deviceBind` }, { title: `文书`, name: `doc`, permission: `mobile:doc` }, { title: `文书`, name: `PDADoc`, permission: `mobile:PDADoc` }, { title: `清点`, name: `count`, permission: `mobile:count` }, { title: `安全核查`, name: `saftCheck`, permission: `mobile:saftCheck` }],
            activeTab: this.$route.params && this.$route.params.activeTab || `timeline`,
            showMore: false,
            surgeryId: this.$route.query.surgeryId && parseInt(this.$route.query.surgeryId) || 0,
            surgeryInfo: this.$route.params.surgeryInfo || sessionSurgeryInfo

        }
    },
    computed: {
        ...mapGetters([`currentUser`, `screenHeight`, `ward_auth`, `active_hospital_ward`, `permissions`])
    },
    created() {
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
        })
    },
    beforeRouteLeave(to, from, next) {
        sessionStorage.setItem(`surgeryId`, this.surgeryId)
        sessionStorage.setItem(`surgeryInfo`, JSON.stringify(this.surgeryInfo))
        next()
    },
    mounted() {
    },
    methods: {
        isHavePermission(permiskey) {
            return this.permissions && this.permissions.findIndex(item => item.permission === `${permiskey}`) != -1
        },
        back() {
            this.$router.push({ path: `/m_baseInfo`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo } }).catch(err => err)
        },
        goPath(path) {
            let pathinfo = { name: path, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, prevPath: `baseInfo` } }
            console.log(pathinfo)
            this.$router.push(pathinfo).catch(err => err)
        },
        loadAllUsers() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
                req.then(async data => {
                    that.users = data
                    resolve()
                }).catch(e => reject(e))
            })
        }
    },
    watch: {
        activeTab: function(newVlaue, oldValue) {
            if (newVlaue == `count` && this.surgeryId != 0) {
                this.goPath(`CountingList`)
            }
            // if (newVlaue == `文书` && this.surgeryId != 0) {
            //     // this.goPath(`IframeDoc`)
            //     this.goPath(`DoucmentList`)
            // }
        },
        $route: function(newUrl, oldUrl) {
        }
    }
}
</script>
<style lang="less" scoped>
@import './mobile_common.css';
.page {
  background-color: rgba(242, 242, 246, 1);
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 21px;
}

.block_14 {
  background-color:#08b698;
  background-size: 100% 100%;
}

.group_1 {
  margin-left: 20px;
}

.text_69 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  letter-spacing: -0.30000001192092896px;
  font-family: SFProText-Semibold;
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
  line-height: 18px;
}

.thumbnail_7 {
  width: 17px;
  height: 11px;
  margin: 4px 0 3px 219px;
}

.thumbnail_8 {
  width: 15px;
  height: 11px;
  margin: 3px 0 4px 5px;
}

.image_6 {
  width: 25px;
  height: 12px;
  margin: 3px 0 3px 5px;
}

.group_2 {
  height: 54px;
  margin: 0px 3px 0 0;
}

.label_3 {
  width: 40px;
  height: 44px;
}

.text_70 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 17px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: right;
  white-space: nowrap;
  line-height: 24px;
}

.text_3 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin: 11px 0 0 103px;
}

.block_15 {
  padding-bottom: 1px;
}

.box_3 {
  background-color: rgba(255, 255, 255, 1);
  padding: 12px 16px 8px 16px;
}

.image-text_5 {
  width: 261px;
}

.image_7 {
  width: 52px;
  height: 52px;
}

.text-group_4 {
  margin-bottom: 1px;
}

.text-wrapper_48 {
  width: 199px;
}

.text_4 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: SourceHanSansCNVF-Medium;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text_5 {
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  font-family: SourceHanSansCNVF-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 4px;
}
/deep/ .van-tabs__line {
  background-color: #04a891;
}
.text_6 {
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 15px;
  font-family: SourceHanSansCNVF-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 21px;
  margin: 4px 64px 0 0;
}

.image-text_6 {
  width: 64px;
  margin: 10px 58px 0 139px;
}

.text-group_2 {
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 12px;
  font-family: SourceHanSansCNVF-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 17px;
}

.surgery {
    border-top: 1px dashed #ffffff;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    flex-wrap: wrap;
    justify-content: left;
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
    div {
        width: 50%;
        height:25px;
        line-height:25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        span {
        display: block;
        width: 40%;
        height:25px;
        line-height:25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        float: left;
      }
    }
    .time{
        flex-basis:100% !important;
    }
}

.thumbnail_9 {
  width: 12px;
  height: 12px;
  margin: 4px 0 1px 0;
}

.box_4 {
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  padding: 0px 10px;
  margin-top:5px;
  /* 1. 让导航栏出现横向滚动条 */
/deep/ .van-tabs__wrap--scrollable .van-tabs__nav {
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
}

/* 2. 让单个 tab 不压缩、不换行 */
/deep/ .van-tabs__wrap--scrollable .van-tab {
  flex-shrink: 0;   /* 关键：不被压缩 */
  white-space: nowrap;
  padding: 0 24px;  /* 想再宽一点就继续加大 */
}

}

.group_3 {
  margin-top: 11px;
}

.text_71 {
  overflow-wrap: break-word;
  color: rgba(0, 150, 136, 1);
  font-size: 16px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.group_4 {
  background-color: rgba(0, 150, 136, 1);
  border-radius: 1px;
  width: 32px;
  height: 3px;
  margin-top: 10px;
}

.text_72 {
  overflow-wrap: break-word;
  color: rgba(150, 151, 153, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 11px;
}

.text_73 {
  overflow-wrap: break-word;
  color: rgba(150, 151, 153, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 11px;
}

.text_74 {
  overflow-wrap: break-word;
  color: rgba(150, 151, 153, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 11px;
}

.text_75 {
  overflow-wrap: break-word;
  color: rgba(150, 151, 153, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 11px;
}
.text_76 {
  overflow-wrap: break-word;
  color: rgba(150, 151, 153, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 11px;
}

.image_3 {
  width: 58px;
  height: 44px;
  margin-left: -37px;
}

.box_5 {
  background-color: rgba(255, 255, 255, 1);
  margin-top: -1px;
  padding: 12px 22px 10px 16px;
}

.text_13 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 15px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 21px;
  margin-right: 307px;
}

.group_6 {
  width: 210px;
  margin: 11px 127px 0 0;
}

.text_77 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_78 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.group_7 {
  width: 322px;
  margin: 10px 15px 0 0;
}

.text_79 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_80 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.group_8 {
  width: 334px;
  margin: 10px 3px 0 0;
}

.text_81 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_82 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_83 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.group_9 {
  width: 337px;
  margin-top: 10px;
}

.text_84 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_85 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_86 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_87 {
  overflow-wrap: break-word;
  color: rgba(50, 119, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_25 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 15px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 21px;
  margin: 22px 307px 0 0;
}

.group_10 {
  width: 334px;
  margin: 11px 3px 0 0;
}

.text_88 {
  overflow-wrap: break-word;
  color: rgba(245, 34, 45, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_89 {
  overflow-wrap: break-word;
  color: rgba(245, 34, 45, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_90 {
  overflow-wrap: break-word;
  color: rgba(245, 34, 45, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.group_11 {
  margin: 10px 57px 0 0;
}

.text_91 {
  overflow-wrap: break-word;
  color: rgba(245, 34, 45, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_92 {
  overflow-wrap: break-word;
  color: rgba(245, 34, 45, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_93 {
  overflow-wrap: break-word;
  color: rgba(245, 34, 45, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.group_12 {
  width: 266px;
  margin: 10px 71px 0 0;
}

.text_94 {
  overflow-wrap: break-word;
  color: rgba(245, 34, 45, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_95 {
  overflow-wrap: break-word;
  color: rgba(245, 34, 45, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_34 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 15px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 21px;
  margin: 22px 307px 0 0;
}

.group_13 {
  width: 334px;
  margin: 11px 3px 0 0;
}

.text_96 {
  overflow-wrap: break-word;
  color: rgba(0, 150, 136, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_97 {
  overflow-wrap: break-word;
  color: rgba(0, 150, 136, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_98 {
  overflow-wrap: break-word;
  color: rgba(0, 150, 136, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

.text_38 {
  overflow-wrap: break-word;
  color: rgba(0, 150, 136, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Mobile/SurgeryDetail.vue